import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '2226605141499138';
interface AppProps {
  showSocialProofPopup?: boolean;
  showTestimonials?: boolean;
}
export function App({
  showSocialProofPopup = true,
  showTestimonials = true
}: AppProps) {
  useEffect(() => {
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-mist font-sans text-ink selection:bg-gold selection:text-brand-deep" data-id="element-0" data-mp="38kqau06b9zv7">
      <noscript data-id="element-1" data-mp="3dmfqxu8e53q5">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3diruonbka37q" />
      </noscript>

      <Hero data-id="element-3" data-mp="36hxla6f4y2t" />
      <main data-id="element-4" data-mp="3686fj9n0kvj">
        <ProblemSection data-id="element-5" data-mp="35ozexlizgwa" />
        <SolutionSection data-id="element-6" data-mp="356wxj89s6fx" />
        <BonusesSection data-id="element-7" data-mp="38kvshhq5xim" />
        <BenefitsSection data-id="element-8" data-mp="3ud1ftael3qb5" />
        <OfferSection data-id="element-9" data-mp="3ubrg6gs32a2e" />
        <GuaranteeSection data-id="element-10" data-mp="3uc9inv5c9kir" />
        {showTestimonials && <Testimonials data-id="element-11" data-mp="d4e5lt427cwp" />}
        <FAQSection data-id="element-12" data-mp="d3mkjc838xko" />
        <FinalCTA data-id="element-13" data-mp="d45uo6rhyho5" />
      </main>
      <Footer data-id="element-14" data-mp="d2bfl92wpjrz" />
      {showSocialProofPopup && <PurchasePopup data-id="element-15" data-mp="86mfn4mz60v5" />}
    </div>;
}